import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { Ng5SliderModule } from 'ng5-slider';

import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavComponent } from './component/nav/nav.component';
import { HomeComponent } from './component/home/home.component';
import { GyztComponent } from './component/gyzt/gyzt.component';
import { YfgcComponent } from './component/yfgc/yfgc.component';
import { XzComponent } from './component/xz/xz.component';
import { TdComponent } from './component/td/td.component';
import { SqComponent } from './component/sq/sq.component';
import { SyffComponent } from './component/syff/syff.component';
import { HzComponent } from './component/hz/hz.component';
import { VsBtComponent } from './component/td/vs-bt/vs-bt.component';
import { VsBotComponent } from './component/td/vs-bot/vs-bot.component';
import { VsNsmComponent } from './component/td/vs-nsm/vs-nsm.component';
import { AzComponent } from './component/syff/az/az.component';
import { DetailsComponent } from './component/xz/details/details.component';
import { PipePipe } from './pipe.pipe';
import { WebComponent } from './component/syff/web/web.component';
import { OfficeComponent } from './component/syff/office/office.component';
import { AppletsComponent } from './component/syff/applets/applets.component';
import { CountComponent } from './component/count/count.component';



@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HomeComponent,
    GyztComponent,
    YfgcComponent,
    XzComponent,
    TdComponent,
    SqComponent,
    SyffComponent,
    HzComponent,
    VsBtComponent,
    VsBotComponent,
    VsNsmComponent,
    AzComponent,
    DetailsComponent,
    PipePipe,
    WebComponent,
    OfficeComponent,
    AppletsComponent,
    CountComponent,

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    Ng5SliderModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
